<script setup lang='ts'>
import useUserStore from "~/stores/user";

const route = useRoute();
const router = useRouter();
const userStore = useUserStore();
const isLoggedIn = computed(() => userStore.isAuthenticated);

const onLogout = () => {
  userStore.logout();

  if (route.meta.middleware === "auth")
    router.push({ path: "/" });
};
</script>

<template>
  <UserMenu
    v-if="isLoggedIn && userStore.user"
    :full-name="userStore.user.fullName"
    :with-theme-switcher="false"
    :logo-initials-size="40"
    @logout="onLogout()"
  />
</template>
